var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserAcces(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144.4 120.9",
    style: {
      enableBackground: "new 0 0 144.4 120.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.1,102.3c0,1.1,0.1,2.2,0.2,3.3H0.5c-0.2-1.9-0.3-3.9-0.3-5.9c0-15.4,6.9-29.1,17.8-38.3 c2.6-2.2,6.4-2.1,9.1-0.1c6.5,4.7,14.5,7.4,23.1,7.4c9.2,0,17.7-3.1,24.4-8.4c1.9-1.5,4.6-1.4,6.6,0.1c3.9,3,7.3,6.6,10.1,10.7 C74.1,71,60.1,85,60.1,102.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.3,30.3c0,9.9-4.7,18.8-12,24.4c-5.2,4-11.7,6.4-18.8,6.4c-7.2,0-13.7-2.4-19-6.5 C24.4,49,19.7,40.2,19.7,30.3c0-17,13.8-30.8,30.8-30.8C67.5-0.5,81.3,13.3,81.3,30.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.2,89.3h-34.8c-2.4-3.2-5.8-5.6-9.7-6.8c-1.8-0.6-3.8-0.9-5.8-0.9c-10.3,0-18.9,8.3-19.4,18.6 c-0.1,1.5,0.1,3,0.3,4.4c1.7,9,9.6,15.9,19.1,15.9c9.6,0,17.6-7,19.1-16.2h11c0.2,0,0.3,0,0.5,0c1.2,0.2,2.1,1.3,2.1,2.5v4.1 c0,2.1,1.7,3.8,3.8,3.8h6.1c2.2,0,4-1.8,4-4v-3.5c0-1.7,1.4-3.1,3.1-3.1h1c1.7,0,3.1-1.4,3.1-3.1v-8.4 C144.6,90.8,143.1,89.3,141.2,89.3z M92,108.3c-3.3,0.5-6.3-1.2-7.7-3.8c-0.8-1.4-1.1-3-0.8-4.7c0.5-3.1,3-5.7,6.2-6.2 c5-0.8,9.3,3.5,8.5,8.5c-0.1,0.8-0.4,1.6-0.8,2.4C96.3,106.5,94.3,108,92,108.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAcces);
export default __webpack_public_path__ + "static/media/UserAcces.10824f5ab6ddc31856882daf6d92c17a.svg";
export { ForwardRef as ReactComponent };